import {AfterContentChecked, ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {SizeGroupRelationEntityModel} from "../size-group-relation-entity.model";
import {CompositeProductSearchPageComponent} from "../../composite-product/composite-product-search-page/composite-product-search-page.component";
import {ProductLineEditPageComponent} from "../../product-line/product-line-edit-page/product-line-edit-page.component";
import {CompositeProductEditPageComponent} from "../../composite-product/composite-product-edit-page/composite-product-edit-page.component";
import {ProductLineSearchPageComponent} from "../../product-line/product-line-search-page/product-line-search-page.component";
import {SellableSizeRelationData, SizeGroupRelationData} from "../size-group-relation.data";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";


@Component({
    selector: "wbo-size-group-relation-page",
    templateUrl: "./size-group-relation-edit-page.component.html",
    providers: [provideEntityModel(SizeGroupRelationEntityModel)]
})

export class SizeGroupRelationEditPageComponent extends AbstractEditPage implements AfterContentChecked {
    ProductLineSearchPageComponent = ProductLineSearchPageComponent;
    ProductLineEditPageComponent = ProductLineEditPageComponent;
    CompositeProductSearchPageComponent = CompositeProductSearchPageComponent;
    CompositeProductEditPageComponent = CompositeProductEditPageComponent;
    EditMode = EditMode;

    constructor(public model: SizeGroupRelationEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    onValueChange() {
        const sellableArr: Array<any> = this.model.data.sellableSizeRelations;
        for (let i = 0; i < sellableArr.length; i++) {
            sellableArr[i].sellableSize = null;
        }
    }

    sellableSizeRelationsSaved(entity: SellableSizeRelationData): void {
        const data: SellableSizeRelationData = entity;
        if (entity.standardProduct) {
            this.model.data.standardSellable.sellableId = data.sellable.sellableId;

            const sellableArr: Array<any> = this.model.data.sellableSizeRelations;
            for (let i = 0; i < sellableArr.length; i++) {
                if (data.sellable.sellableId != sellableArr[i].sellable.sellableId) {
                    sellableArr[i].standardProduct = false;
                }
            }
        }
    }

    ngAfterContentChecked(): void {
        // when adding the products it is auto reloading the sellables causing a change detection error
        this.changeDetectorRef.detectChanges();
    }

    addingAnother(previousEntity: SizeGroupRelationData): void {
        this.model.data.sellableSizeGroup.id = previousEntity.sellableSizeGroup.id;
    }
}
